export const ApiGsi = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const authGsi = async (authCode) => {
    const result = await axios.post('/auth/gsi', {
      authCode
    })

    return result.data
  }

  const authGsiAccounts = async (authCode) => {
    const result = await axios.get('/auth/gsi/accounts')
    return result.data
  }

  return {
    authGsi,
    authGsiAccounts
  }
}
